import { DeliveryAreaListResponseItemType } from "@sellar-io/api-v2/types";
import { daysOfWeek, getNextDeliveryDate } from "@sellar-io/common";

export const getNextDirectDeliveryDate = ({
  deliveryArea,
  startDateReference,
}: {
  startDateReference: Date;
  deliveryArea: Pick<
    DeliveryAreaListResponseItemType,
    | "weeklyCadence"
    | "orderCutOffDaysBefore"
    | "startAt"
    | "orderCutOffTime"
    | "includeWeekend"
    | "systemDefinedType"
  > & {
    DeliveryAreaDays: { day: daysOfWeek }[];
  };
}) => {
  const deliveryDateResult = getNextDeliveryDate({
    ...deliveryArea,
    startDateReference,
    deliveryAreaDays: deliveryArea.DeliveryAreaDays.map(({ day }) => ({
      day,
    })),
  });
  return deliveryDateResult.isSuccess
    ? {
        ...deliveryDateResult.data,
        dispatchDate:
          deliveryArea.systemDefinedType === "sellarDistribution"
            ? deliveryDateResult.data.dispatchDate
            : deliveryDateResult.data.deliveryDate,
      }
    : null;
};
